<template>
    <div class="inde">
         <!-- 创建代金券top标题 -->
    <div class="cons">
      <!-- 顶部的样式 -->
      <div class="conys">
        <div class="quan">
          <span class="pri">{{ inputpri }}元</span>
          <span class="pris">满{{ inputmk }}元可用</span>
        </div>
        <div class="quan_rig">
          <span class="quan_title">{{ inputquan }}</span>
          <span class="quan_ts">[仅限于线上小程序使用]</span>
          <span class="quan_tts">提示：{{ inputips }}</span>
          <span class="quan_qx"></span>
          <span class="quan_tts">有效期：{{ inputstart }}~{{ inputend }}</span>
        </div>
      </div>

      <div class="con_top">
        <div class="cons_left">
          <div class="cons_quan">归属商户：长安典当行</div>

          <div class="cons_quan">
            <span>优惠券名称：</span>
            <el-input placeholder="请输入券名称" v-model="inputquan" clearable />
          </div>

          <div class="cons_quan">
            <span>优惠券金额：</span>
            <el-input
              placeholder="请输入优惠金额"
              type="number"
              v-model="inputpri"
              clearable
            />
          </div>

          <div class="cons_quan">
            <span>使用门槛：</span>
            <el-input
              placeholder="请输入门槛金额"
              type="number"
              v-model="inputmk"
              clearable
              @blur="blur"
            />
            <span class="context">**满减金额不能小于优惠券金额**</span>
          </div>
        </div>

        <div class="cons_left">
          <div class="cons_quan">归属商户：长安典当行</div>
          <div class="cons_quan">
            <span>有效时间：</span>

            <el-date-picker
              v-model="valuedate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @blur="datevalue"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>

          <div class="cons_quan">
            <span>使用说明：</span>
            <el-input placeholder="请输入使用说明" v-model="inputips" clearable />
          </div>

          <div class="cons_quan">
            <span>证件号码：</span>
            <el-input placeholder="请输入领券人证件号码" v-model="inputuser" clearable />
          </div>
        </div>
      </div>

      <div class="cont_btn">
        <el-button type="primary" icon="el-icon-upload" @click="createQaun"
          >确定创建并发放</el-button
        >

        <el-dialog title="温馨提示" :visible.sync="dialog" width="20%">
          <span>请把券的信息填写完整</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialog = false">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    </div>
</template>
<script>
export default {
    name:'Create',
    data(){
        return{
    drawer: false,
      inputquan: "请输入券名称",
      inputpri: 0,
      inputmk: 0,
      valuedate: "",
      inputips: "续当可用，商城不可用",
      inputuser: "",
      inputstart: "20**-**-**",
      inputend: "20**-**-**",
      dialog: false,

      ACCESS_TOKEN: "",
        }
    },
    methods:{
          datevalue() {
      (this.inputstart = this.valuedate[0]), (this.inputend = this.valuedate[1]);
    },
        blur() {
      if (this.inputmk < this.inputpri) {
        this.$message({
          message: "满减金额不能小于优惠券金额哦",
          type: "warning",
        });
        this.inputmk = "";
      }
    },

    createQaun() {
      if (this.inputpri !== 0 && this.valuedate !== "" && this.inputuser !== "") {
        this.axios
          .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("coupons").add({data:{condition:"${this.inputmk}",end:"${this.inputend}",money:"${this.inputpri}",start:"${this.inputstart}",state:false,tips:"${this.inputips}",title:"${this.inputquan}",userid:"${this.inputuser}"}})`,
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              this.$notify({
                title: "创建成功成功",
                message: "代金券已创建成功",
                type: "success",
              });

              setTimeout(()=>{
                 this.$router.go(0);
              },1000)
            }else{
              this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
            
            }
          });
      } else {
        this.dialog = !this.dialog;
      }
    },
    },
    created(){
        // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //获取到this.ACCESS_TOKEN
           //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()

    },
    mounted(){
      // setTimeout(()=>{
      //     this.axios.get("/getUser/getToken",{data:{
      //       eid:sessionStorage.getItem("userId")
      //     }}).then(res=>{
      //       if(res.data[0].time > 2){
      //          this.$notify.error({
      //         title: '错误提示',
      //         message: '密钥过期啦，请刷新页面'
      //       });
      //       }
      //     })
      // },700)
    }
}
</script>
<style scoped>

.context {
  font-size: 12px;
  color: red;
}
.cont_btn {
  margin-top: 200px;
  width: 93%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.cons {
  margin-top: 15px;
  width: 100%;
  height: 850px;
  background-color: #ffffff;
  border-radius: 7px;
}
.con_top {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.cons_left {
  display: flex;
  flex-direction: column;
}
.cons_left {
  margin: 20px 0;
}
.cons_quan {
  margin: 18px 0;
  display: flex;
  flex-direction: row;
}
.conys {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.quan {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  width: 200px;
  height: 180px;
  background-color: #e74f4f;
  color: #ffffff;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.pri {
  font-size: 30px;
  font-weight: bold;
}
.pris {
  font-size: 20px;
}
.quan_rig {
  margin-top: 10px;
  width: 350px;
  height: 180px;
  background-color: #f3f3f3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.quan_title {
  font-size: 22px;
}
.quan_ts {
  font-size: 19px;
  color: #e01836;
}
.quan_tts {
  font-size: 15px;
  color: #8b8b8b;
}
.quan_qx {
  width: 98%;
  border: 1px dashed #cccccc;
  overflow: hidden;
  margin: 15px 0;
}
</style>